import PortlandShortIcon from '../../../../icons/portland-short.icon';
import ToolsetIcon from '../../../../icons/toolset.icon';
import "./index.styles.scss";
import RecommendedToolRow from './recommende-tool.row';
import PlusIcon from '../../../../icons/plus.icon';
import { Dropdown } from 'react-bootstrap';
import SearchInput from '../../../../search-input/search-input.component';
import { useEffect, useMemo, useRef, useState } from 'react';
import { postData } from '../../../../../Utils/commonApi';
import { useAuth } from '../../../../context/Auth';
import { CallToast } from '../../../../PriceCalculator/modals/CustomToast';
import integrationUtils from '../../../../../Utils/integration.utils';

const CoveredTechnologies = ({ technologies }) => {
  if (!technologies?.length) return null;

  const filteredTechnologies = technologies.filter(item => item?.TechnologyName !== null);

  if (filteredTechnologies.length === 0) return null;

  return (
    <tr>
      <td className="covered-technologies-container" colSpan={5}>
        <div className="flex flex-col gap-8">
          <span className="covered-technologies-title">
            This license will also cover the following technologies:
          </span>
          <div className="flex flex-col gap-8">
            {filteredTechnologies.map((technology, index) => (
              <div key={index} className="flex items-center gap-4">
                <ToolsetIcon />
                <span className="covered-technologies-list-item">
                  {technology.TechnologyName}
                </span>
              </div>
            ))}
          </div>
        </div>
      </td>
    </tr>
  );
};

const AddTool = ({ onAddTool, technologyEnum }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [toolsList, setToolsList] = useState([]);
  const [search, setSearch] = useState('');
  const searchRef = useRef(null);
  const { authTokens } = useAuth();
  const [toolLoader, setToolLoader] = useState(false);

  useEffect(() => {
    if (toolsList?.length == 0) {
      if (dropdownOpen) getToolsList();
    }
  }, [dropdownOpen])
  function getToolsList(searchString) {
    setToolLoader(true);
    postData(authTokens, "GetAllIntegrationsByTechologyType", {
      ShowAll: true,
      accessKey: JSON.parse(localStorage.getItem("user_MessageObj")),
      TechnologyTypeEnum: technologyEnum ?? 0,
      Search_text: searchString ?? search ?? '',
      ObjId_Customer: 14925266,
    })
      .then((response) => {
        if (response?.mr?.Success) {
          setToolsList(response?.Integration_List);
          setToolLoader(false);
        }
      })
      .catch((err) => {
        CallToast("Something went wrong", false, false, "v2style");
        setToolLoader(false);
        console.log(err);
      });
  }

  const handleToolSearch = (value) => {
    setSearch(value);
    getToolsList(value);
  }

  return (
    <Dropdown
      className='add-tool-dropdown transparennt-wrapper-dropdown my-dropdown my-dropdown-common'
      show={dropdownOpen}
      onToggle={(isOpen) => {
        setDropdownOpen(isOpen);
        if (isOpen) {
          setTimeout(() => {
            searchRef.current?.focus();
          }, 10);
        }
      }}
    >
      <Dropdown.Toggle>
        <div className='f-grey d-flex align-items-center'>
          <div className="plus-icon">
            <PlusIcon />
          </div>
          <span>Add Tool</span>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className='menu' popperConfig={{ strategy: 'fixed' }}>
        <div className='menu-content'>
          <SearchInput
            passedRef={searchRef}
            value={search}
            placeholder="Search"
            className="bg-white py-1"
            onChange={(value) => { handleToolSearch(value); }}
          />
          {
            toolLoader ? <div className='d-flex align-items-center justify-content-center w-100 py-3'>
              <div className="msp-service-update-loader mr-2 mr-1"></div>
              <div className='f-400 f-14 f-grey'>Loading..</div>
            </div> : <></>}

          <div className='tools-list hide-scrollbar'>
            {toolsList?.map((tool, index) => (
              <div key={index} className='tool-item' onClick={() => {
                onAddTool(tool);
                setDropdownOpen(false);
              }}>
                <div className='tool-item-left'>
                  <img className='tool-item-icon' width={16} height={16} src={integrationUtils.getImagePath(tool?.IntegrationId, tool?.ToolIcon)} alt={tool?.IntegrationName} />
                  <span>{tool?.IntegrationName}</span>
                </div>
                <div className='tool-item-right f-grey'>
                  <PlusIcon />
                  <span>Add</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>

  )
}

const RecommendedToolsTable = ({
  getPageData = () => { },
  recommendedTools,
  totalSave,
  coveredTechnologies,
  onAddTool,
  technologyEnum,
  isInvestment
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const searchRef = useRef(null);
  const tableHeaders = [
    'Tool(s)',
    'Qty',
    'Contract End',
    'Price',
    'Total',
  ];

  const isAnyLicenseCovered = useMemo(() => {
    return recommendedTools?.some(tool => tool?.IsCovered);
  }, [recommendedTools]);

  return (
    <div className="recommended-tools-wrapper">
      <table>
        <colgroup>
          <col style={{ width: '30%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '22%' }} />
          <col style={{ width: '21%' }} />
          <col style={{ width: '17%' }} />
        </colgroup>
        <thead className="recommended-tools-header">
          <tr className="recommended-tools-header-row">
            <th>
              <div className="flex items-center gap-8">
                <div className='portland-short-icon-wrapper'>
                  <PortlandShortIcon width={14} height={14} />
                </div>
                <span className='f-white'>Recommended</span>
              </div>
            </th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr className="tools-header-row">
            {tableHeaders.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {recommendedTools?.map((tool, index) => (
            <>
              <RecommendedToolRow key={`tool-${index}`} tool={tool} recommendedTools={recommendedTools} onRowClick={onAddTool} />
              <CoveredTechnologies technologies={tool?.SecurityStackReportOtherTechnologies_List} />
            </>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td>
              {!isAnyLicenseCovered && (
                <AddTool onAddTool={onAddTool} technologyEnum={technologyEnum} isInvestment={isInvestment} />
              )}
            </td>
            <td></td>
            <td></td>
            <td className="total-title">
              {isInvestment ? 'Investment' : 'You Save'}
            </td>
            <td className="total-save f-black">{totalSave}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default RecommendedToolsTable;